/**
 * Every app should only use one store which combine different reducers
 */

import { createStore, combineReducers, compose } from 'redux';
import persistState from 'redux-localstorage'
import { routerReducer } from 'react-router-redux';
// import app from './reducers';
import {episodes} from './reducers';
import {gallery} from './reducers';
import {quizz} from './reducers';

const storageConfig = {key: 'suivez-le-guide-2016'};
const enhancer = compose(
  persistState('quizz', storageConfig), // !!! If shared we rehydrate only quizz state !!! Only "top-level" paths are supported that's why Quizz is not nested in
  window.devToolsExtension ? window.devToolsExtension() : f => f
)

// Add the reducer to your store on the `routing` key
const store = createStore(
  combineReducers({
    episodes: episodes,
    gallery: gallery,
    quizz: quizz,
    routing: routerReducer
  })
  ,window.STATE_FROM_SERVER // default state values or shared data.
  ,enhancer
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js